import { ROLE } from '../../constants';

export const PREFILL_TOKEN_COOKIE = 'lm_prefill_token';
export const TRACKER_COOKIE = 'lm_tracker_ref';

export const PROVIDER_ROLES = [ROLE.ADMINISTRATOR, ROLE.PROVIDER, ROLE.PRACTICE_MANAGER];
